@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  @include border-radius-r2;
  @include typography-v2-body-sm;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--border-soft);
  background-color: var(--surface-soft);
}

.label {
  color: var(--text-soft);
}

.destination {
  color: var(--text-default);
}

.link {
  margin-left: auto;
  color: var(--text-link);
  white-space: nowrap;
}
